import $ from "jquery"
import { trace } from "./helpers.js"
import MMap from "./MMap.js"


const Maps = {

  initMap(index, el) {
    let $map = $(el);
    let id = $map.attr("id");
    let mapDataSelector = $map.data("map-data");
    let $mapData = $(mapDataSelector);
    if (!$map || !id || !mapDataSelector || !$mapData.length) {
      // trace("map init failed", index, el);
    }
    let mmap = new MMap({$map, id, $mapData});

  },

  // ### init ###
  init() {
    $(".m-map").each( this.initMap );
  }

}

export default Maps;